import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WhatsappTemplateService } from '../../whatsapp-template/whatsapp-template.service';

@Component({
  selector: 'app-messagify-user-popup',
  templateUrl: './messagify-user-popup.component.html',
  styleUrls: ['./messagify-user-popup.component.scss']
})
export class MessagifyUserPopupComponent {
  constructor(public activeModal: NgbActiveModal, public whatsappTemplateService: WhatsappTemplateService,
  ) {}
  userForm = {
    username: '',
    password: '',
    ipAddress: ''
  };

  save() {
    this.whatsappTemplateService.insertMsgiFlyUserDetails(this.userForm)
      .subscribe({
        next: (res) => {
          this.activeModal.close(res);
        },
        error: (err) => {
          console.error('Error saving:', err);
        }
      });
  }
  close() {
}
}
